import {
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
    Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const PreviewDialog = ({ open, onClose, previewHtml }) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            fullWidth
            PaperProps={{
                sx: { borderRadius: 3, height: '80vh', display: 'flex', flexDirection: 'column' },
            }}
        >
            <DialogTitle
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flexShrink: 0,
                }}
            >
                <Typography variant="h6" sx={{ fontWeight: 700 }}>
                    Vista Previa
                </Typography>
                <IconButton onClick={onClose} size="small">
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{ p: 0, flex: 1, overflow: 'hidden' }}>
                <iframe
                    srcDoc={previewHtml}
                    title="preview"
                    style={{ width: '100%', height: '100%', border: 'none', display: 'block' }}
                />
            </DialogContent>
        </Dialog>
    );
};

export default PreviewDialog;
